export enum ProductConditionAction {
    Include = 'include',
    Exclude = 'exclude',
}

export enum ProductCondition {
    VacancyPreferred = 'vacancy-preferred',
}
